import { GET_ALL_Regions_KMZ } from '../../../common/constants/constants';
import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';
export const getAllRegions = async (network) => {
  try {
    const resp = await apiClient.get(GET_ALL_Regions_KMZ(network), {});
    return resp.data;
  } catch (error) {
    handleApiError(error);
  }
};
